export default __webpack_public_path__ + "static/media/Parent_Illustrations-03.6d125ebb.svg";